import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import {CommonModule} from '@angular/common';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-ui-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui-tooltip.component.html',
  styleUrls: ['./ui-tooltip.component.scss'],
  animations: [
    trigger('showHide', [
      state(
        'closed',
        style({
          opacity: '0',
        })
      ),
      state(
        'opened',
        style({
          opacity: '1',
        })
      ),
      transition('closed => opened', [animate('0.6s linear')]),
      transition('opened => closed', [animate('0.6s linear')]),
    ]),
  ],
})
export class UiTooltipComponent {
  @Input() tTooltip: string = '';
  @Input() isShow: boolean = false;
}
